enum LabelPosition {
  Top,
  Left
}

export default LabelPosition
